module.exports = __webpack_public_path__ + "media/images/profile_verification/thumbs_up_right-4f767ddd8ab630b57fbbdd9e19555e81.png";